function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkflows = function SvgWorkflows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.834 4.986A3.001 3.001 0 0 1 1 4a3 3 0 0 1 5.834-.986C6.888 3.004 6.944 3 7 3h5.25a3.75 3.75 0 1 1 0 7.5h-4.5a1.75 1.75 0 1 0 0 3.5h7.836l-.793-.793a1 1 0 0 1 1.414-1.414l2.5 2.5.707.707-.707.707-2.5 2.5a1 1 0 0 1-1.414-1.414l.793-.793H7.75a3.75 3.75 0 1 1 0-7.5h4.5a1.75 1.75 0 1 0 0-3.5H7c-.057 0-.112-.005-.166-.014Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgWorkflows;